import axios from "axios";
import { store } from "../redux/store";

axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL

axios.defaults.withCredentials = true;

// 设置请求拦截器
axios.interceptors.request.use(config => {
  //如果有user_id就放入
  if(store.getState().userProfileReducer.user !== null){
      config.data = {
        ...config.data,
        user_id: store.getState().userProfileReducer.user.id
      };
  }
  if(store.getState().userProfileReducer.token){
    config.headers['Authorization'] = `Bearer ${store.getState().userProfileReducer.token}`;
  }
  config.headers['Front-End-Route'] = window.location.href;

  return config;
});

axios.interceptors.response.use(response=>response, function (error) {
  // 檢查是否為401
  if (error.response &&
      error.response.status === 401 &&
      store.getState().userProfileReducer.token !== null
  ) {
    handleUnauthorized();
  }
  return Promise.reject(error);
});

function handleUnauthorized(){
  //移除token
  store.dispatch({type: 'logout'})

  // 重新加载当前页面
  window.location.reload();
}

